<template>
  <div class="annset-li">
    <div class="annset-name-desc">
      <div class="annset-name">

         <SVGIcon
          :iconName="'info'"
          :width="'26px'"
          :height="'26px'"
          @click="annotationSetInfo"
        />

      
        <EncodedIdField
          :id="annotationSet.id"
          class="ml-3 mr-3"
          :type="'annotation set'"
          :hideLabel="true"
        />

        <span class="set-name">{{ isDebugMode ? `(${annotationSet.id}) ${annotationSet.name}` : `${annotationSet.name}` }}</span>

      </div>

      <!-- Disbale annotation counts here and only show in details dialog -->
      <!-- <div class="annset-desc">
        <SVGIcon
          :iconName="'image'"
          :width="'18px'"
          :height="'18px'"
        />
        <span>{{ imgCount }}</span>
        <SVGIcon
          :iconName="'tag'"
          :width="'18px'"
          :height="'18px'"
        />
        <span>{{ annotationCount }}</span>

        <template v-if="loadingHash || hashId">
          <SVGIcon
            :iconName="'hash_tag'"
            :width="'18px'"
            :height="'18px'"
          />
          <InlineLoader
            v-if="loadingHash && !hashId"
            :width="'18px'"
            :height="'18px'"
            :border="'2px'"
            class="ml-2"
          />
          <template v-if="hashId">
            <Tooltip :placement="'top-start'" :trigger="'click'">
              <template #body>
                <pre>Full dataset hash copied</pre>
              </template>
              <SVGIcon
                class="icon-copy"
                :iconName="'copy'"
                :width="'16px'"
                :height="'16px'"
                @click.stop="copyToClipboard(hashId)"
              />
            </Tooltip>
            <span>{{ shorten(hashId) }}</span>
          </template>
        </template>
      </div>
 -->



    </div>
    <div v-if="canWrite" class="icon-container">
      <BaseMenu
        :placement="'bottom-start'"
        :appendToBody="true"
        @closed="show_menu = false"
      >
        <IconButton
          v-model="show_menu"
          class="edit-set-icon"
          :icon="'more_vert'"
          :width="22"
          :height="22"
        />
        <template #menu="{closeMenu}">
          <ul>
            <li>
              <BaseMenuButton v-tooltip="'Edit annotation set name and description'" @click.stop="$emit('open-description'), closeMenu()">
                <SVGIcon
                  :iconName="'edit'"
                  :width="'22px'"
                  :height="'22px'"
                />
                <span>Edit</span>
              </BaseMenuButton>
            </li>
            <!-- <li>
              <BaseMenuButton
                v-tooltip="'Generate hash value from dataset and selected annotation set'"
                :disabled="isFrozen"
                @click.stop="generateHash(), closeMenu()"
              >
                <SVGIcon
                  :iconName="'hash_tag'"
                  :width="'22px'"
                  :height="'22px'"
                />
                <span>Generate Hash</span>
              </BaseMenuButton>
            </li> -->
            <li v-if="!isFrozen">
              <BaseMenuButton
                v-tooltip="'Move annotation set to recycle bin. Annotation set will be billed at normal rate until it is purged'"
                class="_danger"
                :disabled="isFrozen"
                @click.stop="$emit('delete-annset'), closeMenu()"
              >
                <SVGIcon
                  :iconName="'trash'"
                  :width="'22px'"
                  :height="'22px'"
                />
                <span>Move to Recycle Bin</span>
              </BaseMenuButton>
            </li>
          </ul>
        </template>
      </BaseMenu>
      <!-- <IconButton
        class="edit-set-icon"
        :icon="'conf_matrix'"
        :width="22"
        :height="22"
        :title="`View Confusion Matrix`"
        :type="''"
        @click.stop="$emit('open-conf-matrix')"
      /> -->
    </div>
  </div>

  <!-- Info Dialog -->
<AnnotationSetInfoModal
    v-model="annotationInfoDialog"
    :annotationSet="annotationSet"
  />


</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';

import SVGIcon from '@/components/SVGIcon.vue';
import IconButton from '@/components/IconButton.vue';
import BaseMenu from '@/components/BaseMenu.vue';
import BaseMenuButton from '@/components/BaseMenuButton.vue';
import EncodedIdField from '@/components/EncodedIdField.vue';
import InlineLoader from '@/components/InlineLoader.vue';
import Tooltip from '@/components/Tooltip.vue';
import AnnotationSetInfoModal from '@/components/DatasetComponent/DatasetManagement/AnnotationSetInfoModal.vue';

import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface.js';


const annotationInfoDialog = ref(false);


/* ---------------- props ---------------- */
const props = defineProps({
  annotationSet: {
    type: Object,
    default: () => ({}),
  },
  numImg: {
    type: Number,
    default: 0,
  },
  numAnnotations: {
    type: Number,
    default: 0,
  },
  refresh: {
    type: Boolean,
    default: false,
  },
  isFrozen: {
    type: Boolean,
    default: false,
  },
  canWrite: {
    type: Boolean,
    default: true,
  },
  hashId: {
    type: String,
    default: null,
  },
});

/* ---------------- emits ---------------- */
const emit = defineEmits([
  'delete-annset',
  'copy-annset',
  'update:numImg',
  'update:numAnnotations',
  'open-conf-matrix',
  'open-description',
  'generate-hash',
]);

/* ---------------- store ---------------- */
const store = useStore();

/* ---------------- state ---------------- */
const dataConnect = new DatastoreConnect(store.state.enterpriseServerUrl);

const imgTotal = ref(0);
const loadingHash = ref(false);
const show_menu = ref(false);

/* ---------------- computed ---------------- */
const isDebugMode = computed(() => store.state.debugMode);

const imgCount = computed({
  get: () => props.numImg,
  set: (v) => emit('update:numImg', v),
});

const annotationCount = computed({
  get: () => props.numAnnotations,
  set: (v) => emit('update:numAnnotations', v),
});

/* ---------------- watchers ---------------- */
watch(
  () => props.hashId,
  () => {
    loadingHash.value = false;
  }
);

/* ---------------- methods ---------------- */
function annotationSetInfo() {
  annotationInfoDialog.value = true;
}

function shorten(hashId) {
  return hashId.slice(0, 8);
}

function generateHash() {
  loadingHash.value = true;
  emit('generate-hash');
}

function copyToClipboard(text) {
  if (navigator.clipboard?.writeText) {
    navigator.clipboard.writeText(text);
  }
}
</script>



<style lang="scss" scoped>

.annset-li-container {
  overflow-y: auto;
  font-size: 0.875rem;
  flex: 1 1;
}

.annset-li {
  display: flex;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
  border-radius: 4px;

  .annset-name-desc {
    flex: 1 1 auto;
  }

  .set-name {
    font-weight: 600;
  }

  .annset-name {
    display: flex;
    flex-direction: row;
    align-items: center;
    @include themify() {
      color: themed('body-text-color');
    }
  }

  .annset-desc {
    display: flex;
    align-items: center;
    @include themify() {
      color: themed('body-text-color-secondary');
    }

    span {
      margin-left: 2px;
      font-size: 0.9rem;
    }

    svg:not(:first-of-type) {
      margin-left: 15px;
    }
  }
}

.annset-li:hover {
  background-color: rgb(237, 232, 232);
}

.annset-li .copy-annset-icon,
.annset-li .delete-annset-icon,
.annset-li .edit-set-icon,
.annset-li:hover .copy-annset-icon,
.annset-li:hover .delete-annset-icon,
.annset-li:hover .edit-set-icon{
  z-index: 3;
  visibility: visible;
  @include themify() {
    color: themed('icon-color-inactive');
  }
}

.annset-li:hover .copy-annset-icon:hover,
.annset-li:hover .edit-set-icon:hover {
  @include themify() {
    color: themed('icon-color-primary');
  }
}

.annset-li:hover .delete-annset-icon:hover {
  @include themify() {
    color: themed('color-red');
  }
}

.annset-li + .annset-li {
  margin-top: 2px;
}

.icon-container {
  display: flex;
  align-items: center;
  margin-left: 12px;
  button + button {
    margin-left: 10px;
  }
  @include themify() {
    color: themed('icon-color-inactive');
  }
}

.icon-copy {
  margin: 0 5px !important;
  @include themify() {
    color: themed('icon-color-primary');
  }
  cursor: pointer;
}

</style>
